module.exports = __webpack_public_path__ + "static/media/synapse-logo.765272c0.png";